import { useState, useEffect } from 'react';

interface DeviceState {
  isMobile: boolean;
  isTablet: boolean;
  isPC: boolean;
}

export const useDevice = (): DeviceState => {
  const [device, setDevice] = useState<DeviceState>({
    isMobile: false,
    isTablet: false,
    isPC: true
  });

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      setDevice({
        isMobile: width < 768,
        isTablet: width >= 768 && width < 1024,
        isPC: width >= 1024
      });
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return device;
};
